import React from "react";

const AppML_Case_Categories = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Case Categories</h1>
      <p>This is the AppML Case Categories page content.</p>
    </div>
  );
};

export default AppML_Case_Categories;
